import palette from './palette';
import { BORDER_RADIUS } from '../constants';
import shadows from './shadows';
import { transparentize } from 'polished';

const MuiTooltip = {
  styleOverrides: {
    tooltip: {
      backgroundColor: palette.common.white,
      boxShadow: shadows[4],
      color: palette.text.secondary,
      borderRadius: BORDER_RADIUS,
    },
    arrow: {
      color: transparentize(0.5, palette.grey[100]),
    },
  },
};

export default MuiTooltip;
